import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useBot } from '../context/BotContext';
import ActivityLogDrawer from './ActivityLogDrawer';
import BurnerWallet from './BurnerWallet';

const { FiCpu, FiBell } = FiIcons;

export default function Header() {
  const { balance, positions, activityLog, settings } = useBot();
  const [showLogs, setShowLogs] = useState(false);

  const isLive = settings.tradingMode === 'live';
  const positionsValue = positions.reduce(
    (acc, p) => acc + (p.buyPrice > 0 ? p.amountSol * (p.currentPrice / p.buyPrice) : 0), 0
  );
  const totalEquity = balance + positionsValue;
  const unreadCount = Math.min(activityLog.length, 3); // visual cap, not a real unread count

  return (
    <>
      <div className="bg-[#1c1c1d] border-b border-[#2c2c2e] px-4 py-3 flex justify-between items-center sticky top-0 z-20">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-500 border border-blue-500/30">
            <SafeIcon icon={FiCpu} className="text-xl" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-white font-bold text-sm leading-tight">{isLive ? 'Live' : 'Equity'}</h1>
              {!isLive && (
                <span className="text-green-400 font-mono text-sm font-bold">{totalEquity.toFixed(2)} SOL</span>
              )}
              {isLive ? (
                <span className="flex items-center gap-1 bg-green-500/20 border border-green-500/40 text-green-400 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider">
                  <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
                  Live
                </span>
              ) : (
                <span className="bg-gray-500/20 border border-gray-500/30 text-gray-400 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider">
                  Paper
                </span>
              )}
            </div>
            {!isLive && (
              <p className="text-gray-400 text-[10px] font-mono flex items-center gap-1">
                Avail: <span className="text-white">{balance.toFixed(2)}</span>
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          {isLive && <BurnerWallet compact />}
          <button
          onClick={() => setShowLogs(true)}
          className="relative w-10 h-10 rounded-full bg-[#2c2c2e] flex items-center justify-center text-gray-400 hover:text-white transition-colors border border-[#3c3c3e]"
        >
          <SafeIcon icon={FiBell} className="text-lg" />
          {unreadCount > 0 && (
            <span className="absolute top-0 right-0 w-3 h-3 bg-red-500 border-2 border-[#1c1c1d] rounded-full" />
          )}
        </button>
        </div>
      </div>

      <ActivityLogDrawer isOpen={showLogs} onClose={() => setShowLogs(false)} activityLog={activityLog} />
    </>
  );
}
